import { executeSource } from "./interpreter_source";

export async function executeScene(sourceCode) {
  const lines = [];
  const originalLog = console.log;
  const originalError = console.error;

  console.log = (...args) => lines.push(args.join(" "));
  console.error = (...args) => lines.push(args.join(" "));

  try {
    const browserSource = sourceCode.replace(/\s*END\s*$/, "").trim();
    await executeSource(browserSource);
    return { ok: true, output: lines.join("\n") };
  } catch (error) {
    const message = error?.message || String(error);
    return { ok: false, output: lines.concat(message).join("\n") };
  } finally {
    console.log = originalLog;
    console.error = originalError;
  }
}